<div class="modal-overlay" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">Nouveau Projet</h2>
      <button class="close-btn" (click)="onClose()">×</button>
    </div>

    <form [formGroup]="projectForm" (ngSubmit)="onSubmit()" class="modal-body">
      @if (!isValidConfig()) {
      <div class="alert alert-error mb-4">
        <mat-icon class="alert-icon">warning</mat-icon>
        <span>La création de projet est désactivée car la configuration des statuts est incomplète. Il doit y avoir au
          moins un statut pour chaque méta-statut (DRAFT, VALIDE, TERMINE).</span>
      </div>
      }

      @if (!hasValidatedTemplate()) {
      <div class="alert alert-error mb-4">
        <mat-icon class="alert-icon">warning</mat-icon>
        <span>La création de projet est désactivée car aucun template FAT validé n'existe. Veuillez d'abord valider un
          template FAT.</span>
      </div>
      }

      @if (!hasValidatedReferential()) {
      <div class="alert alert-error mb-4">
        <mat-icon class="alert-icon">warning</mat-icon>
        <span>La création de projet est désactivée car aucun référentiel de types de documents validé n'existe. Veuillez
          d'abord valider une version dans la gestion des types de documents.</span>
      </div>
      }

      @if (errorMessage()) {
      <div class="alert alert-error mb-4">
        <mat-icon class="alert-icon">error</mat-icon>
        <span>{{ errorMessage() }}</span>
      </div>
      }

      <div class="form-group">
        <label for="name">NOM DU PROJET *</label>
        <input type="text" id="name" formControlName="name" class="form-control" placeholder="ex: Construction Usine A">
      </div>

      <div class="form-group">
        <label for="deliveryAddress">ADRESSE DE LIVRAISON</label>
        <input type="text" id="deliveryAddress" formControlName="deliveryAddress" class="form-control"
          placeholder="ex: 123 Rue de l'Industrie">
      </div>

      <div class="form-row">
        <div class="form-group col">
          <label for="city">VILLE</label>
          <input type="text" id="city" formControlName="city" class="form-control" placeholder="ex: Paris">
        </div>
        <div class="form-group col">
          <label for="zipCode">CODE POSTAL</label>
          <input type="text" id="zipCode" formControlName="zipCode" class="form-control" placeholder="ex: 75001">
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col">
          <label for="availabilityDate">DATE DE MISE À DISPOSITION *</label>
          <input type="date" id="availabilityDate" formControlName="availabilityDate" class="form-control">
        </div>
        <div class="form-group col">
          <label for="deliveryDate">DATE DE LIVRAISON *</label>
          <input type="date" id="deliveryDate" formControlName="deliveryDate" class="form-control">
        </div>
      </div>

      @if (projectForm.errors?.['dateRangeInvalid'] && (projectForm.get('deliveryDate')?.touched ||
      projectForm.get('availabilityDate')?.touched)) {
      <div class="alert alert-error mb-4"
        style="color: #991b1b; background-color: #fee2e2; padding: 0.5rem; border-radius: 4px; font-size: 0.8rem; margin-top: -0.5rem; border: 1px solid #fecaca;">
        La date de livraison doit être postérieure ou égale à la date de mise à disposition.
      </div>
      }

      <div class="form-group">
        <label for="statusId">STATUT DU PROJET *</label>
        <mat-form-field appearance="outline" class="w-full custom-select">
          <mat-select id="statusId" formControlName="statusId" placeholder="Choisir un statut">
            @for (status of statuses; track status.id) {
            <mat-option [value]="status.id">
              <div class="meta-option">
                <span class="status-dot" [style.background-color]="status.color || null"
                  [class]="status.color ? '' : status.metaStatus.toLowerCase()"></span>
                {{ status.name }}
              </div>
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>


      <div class="modal-footer">
        <button type="button" class="btn btn-outline" (click)="onClose()">Annuler</button>
        <button type="submit" class="btn btn-primary"
          [disabled]="projectForm.invalid || !isValidConfig() || !hasValidatedTemplate() || !hasValidatedReferential()">Créer
          le projet</button>
      </div>
    </form>
  </div>
</div>
